<template>
	<div class="cb-hp__wrapper">
		<div ref="parent" class="cb-header cb-transition__slide" id="cb-header">
	      <component v-cb-slide="{ isnew : true , ref: $refs.parent }" :is="'header-1'" :key="$route.path">
	      </component>
	    </div>
	    <div class="cb-body" id="cb-body" role="main">
	    	<div class="cb-body__content">
		    	<div v-cb-animate='true' class="cb-body__wrap">
		    		<div class="cb-section cb-bar">
		    			<div class="cb-bar__wrap" v-cb-link = "'shadow'" v-for="(linked_handle, index) in linked_handles" role="navigation" data-cb-id="choose_account" v-bind:key='index' @click="load(linked_handle)">
							<div class="cb-bar__title">{{st('account_txt')}} #{{ index + 1 }}</div>
					      	<div class="cb-bar__content">
								<span class="cb-bar__desc">{{st('account_signup')}}</span>
								<span class="cb-bar__desc">{{date(linked_handle.created_at)}}</span>
					      	</div>
					      	<div class="cb-truncate" v-if="additionalSummaryInfo(linked_handle.handle)" v-cb-html="additionalSummaryInfo(linked_handle.handle)"></div>
					    </div>
		    		</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
import CBNotification from "@/models/cb-notification";
import Auth from "@/store/common/auth.js";
import PortalHeader from "@/components/collections/headers/PortalHeader"
import MultiEntityMixin from "@/mixins/multi-entity-mixin";

import {
  mapGetters
} from "vuex"
export default {
	components: {
		"header-1": PortalHeader
	},
	data(){
		return{
			customers: undefined
		};
	},
	mixins: [MultiEntityMixin],
	computed: {
	    ...mapGetters([
			'cancan',
			'portal_loaded',
			'linked_handles',
			'authType',
	    ]),
	    accountChooserTxt(){
	    	return "Choose Account";
	    }
	},
	methods: {
		load : function(linked_handle){
			this.$store.commit('SET_CUSTOMER_HANDLE',linked_handle.handle);
			this.$router.replace({
                name: "home"
              });
		},
		additionalSummaryInfo(handle) {
			var customer = this.$store.getters.linkedCustomer(handle);
			return this.nlDataTranslate('account.summary.additionalInfo',
				{"customer" : customer});
		}
	},
	mounted(){
		var token = this.$store.state.auth.jwt;
		this.$store.commit('RESET_LIST');
		this.$store.commit('RESET_CUSTOMER_DATA');
		// Reset invoices on switching account
		this.$store.dispatch('reset_invoice_list');

		if(!token) {
			this.$store.dispatch('reset_auth');
			if(this.$store.state.auth.authType == "email") {
				this.$router.push({name: "portal_login"});
			}
		}
	}

}


</script>
